import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import PrivateRoute from './components/PrivateRoute';
import ExitAuthorizationForm from './components/ExitAuthorizationForm';
import DechargeArgentForm from './components/DechargeArgentForm';
import EmployeesPage from './pages/EmployeesPage';
import DashboardPage from './pages/DashboardPage';
import TransportsPage from './pages/TransportsPage';
import ProfessionPage from './pages/ProfessionPage';
import NotFoundPage from './pages/NotFoundPage'; // Page 404
import MainLayout from './components/MainLayout'; // Layout commun
import ChangePassword from './components/ChangePassword';
import ExitAuthorizationsPage from './pages/ExitAuthorizationsPage';
import EntryAuthorizationsPage from './pages/EntryAuthorizationsPage';
import CreateEntryAuthPage from './pages/CreateEntryAuthPage';
import DocumentLegalsPage from './pages/DocumentsPage';
import DechargeArgentsPage from './pages/DechargeArgentsPage';
import SitesPage from './pages/SitesPage';
import LeavesPage from './pages/LeavesPage';
import PayslipsPage from './pages/PayslipsPage';
import InactifsPage from './pages/InactifsPage';
import HolidaysPage from './pages/HolidaysPage';
import AdminBrandingPage from './pages/AdminBrandingPage';
import { BrandingProvider } from './context/BrandingContext';
import CreateMissionPage from './pages/CreateMissionPage';
import MissionOrdersPage from './pages/MissionOrdersPage';
import SettingsPage from './pages/SettingsPage';
import AdminSettingsPage from './pages/AdminSettingsPage';
import CreateDechargePage from './pages/CreateDechargePage';
import CreateExitAuthPage from './pages/CreateExitAuthPage';
import ReportsPage from './pages/ReportsPage';
import ContractsPage from './pages/ContractsPage';

const App = () => {
  return (
    <BrandingProvider>
      <Router>
        <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<Navigate to="/login" />} /> {/* Redirection vers /login */}

        {/* Private Routes (Groupées sous MainLayout) */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <MainLayout />
            </PrivateRoute>
          }
        >
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="employees" element={<EmployeesPage />} />
          <Route path="transports" element={<TransportsPage />} />
          <Route path="professions" element={<ProfessionPage />} />
          <Route path="create-exit-auth" element={<CreateExitAuthPage />} />
          <Route path="create-entry-auth" element={<CreateEntryAuthPage />} />
          <Route path="create-decharge-argent" element={<CreateDechargePage />} />
          <Route path="create-mission" element={<CreateMissionPage />} />
          <Route path="/mission-orders" element={<MissionOrdersPage />} />
          <Route path="/decharge-argents" element={<DechargeArgentsPage />} />
          <Route path="/exit-authorizations" element={<ExitAuthorizationsPage />} />
          <Route path="/entry-authorizations" element={<EntryAuthorizationsPage />} />
          <Route path="/documents-legaux" element={<DocumentLegalsPage />} />
          <Route path="/sites" element={<SitesPage />} />
          <Route path="/leaves" element={<LeavesPage />} />
          <Route path="/payslips" element={<PayslipsPage />} />
          <Route path="/holidays" element={<HolidaysPage />} />
          <Route path="/inactifs" element={<InactifsPage />} />
          <Route path="/branding" element={<AdminBrandingPage />} />
          <Route path="/settings" element={<AdminSettingsPage />} />
          <Route path="/admin-settings" element={<AdminSettingsPage />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/contracts" element={<ContractsPage />} />
        </Route>

        {/* 404 Page Not Found */}
        <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </BrandingProvider>
  );
};

export default App;